import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


export default function AuthCallback() {
  const navigate = useNavigate();

 useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');

    if (!code) {
      console.error('Missing auth code');
      return;
    }

    // build query string
    const search = new URLSearchParams({ code });
    if (state) search.set('state', state);

    // same-origin call (Nginx proxies /api to Node)
  window.location.replace(`/api/auth?${search.toString()}`);
  }, [navigate]);

  return <p>Signing you in…</p>;
}